// apiConfig.js
const baseURL = "https://www.easyday.com.tw/api/userCRUD";
export default baseURL;